import React, { useEffect, useRef } from 'react'
import { Typography, Container } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '@utils/messages'
import ProtocolsAndArticlesBody from '@src/components/ProtocolsAndArticles/ProtocolsAndArticlesBody'
import SectionAccordion, {
  useSectionAccordion,
} from '@src/components/SectionAccordion'
import Chromatograms from '@src/components/Chromatograms'

const ACCORDION_KEY = 'PRODUCT_PROTOCOLS_AND_ARTICLES'

const ProductProtocolsAndArticles = ({
  chromatograms,
  documents,
  productId,
  updateSkipToLinks,
}) => {
  const { accordionProps, toggleIsAccordionOpen } =
    useSectionAccordion(ACCORDION_KEY)

  const ref = useRef(null)

  useEffect(() => {
    if (updateSkipToLinks && ref.current) {
      updateSkipToLinks('protocols', ref)
    }
  }, [updateSkipToLinks])

  return (
    <SectionAccordion
      testId="pdp-protocols-articles"
      {...accordionProps}
      toggleAccordion={toggleIsAccordionOpen}
      renderHeading={() => (
        <Typography variant="h2" component="h2" ref={ref}>
          <FormattedMessage {...messages.PROTOCOLS_AND_ARTICLES} />
        </Typography>
      )}
    >
      <Container maxWidth="lg">
        <ProtocolsAndArticlesBody documents={documents} productId={productId} />
        {chromatograms.length > 0 && (
          <Chromatograms chromatograms={chromatograms} />
        )}
      </Container>
    </SectionAccordion>
  )
}

export default ProductProtocolsAndArticles
